import { Icon } from '@chakra-ui/react';

export const HamburgerRedIcon = ({ onClick }: any) => {
	return (
		<Icon
			w="26"
			h="18"
			viewBox="0 0 26 18"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			onClick={onClick}
		>
			<rect
				width="16"
				height="2"
				fill="#FF3F3F"
			/>
			<rect
				y="8"
				width="26"
				height="2"
				fill="#FF3F3F"
			/>
			<rect
				y="16"
				width="26"
				height="2"
				fill="#FF3F3F"
			/>
		</Icon>
	);
};
